// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bar-interface {
  max-width: 1200px;
  margin: 0 auto;
  animation: slideIn 0.3s ease;
}

.bar-interface h2 {
  font-size: 2.5rem;
  margin-bottom: 2rem;
  text-align: center;
  background: linear-gradient(135deg, #00ff88 0%, #00ccff 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.drinks-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 1.5rem;
  margin-bottom: 2rem;
}

.person-section {
  margin-bottom: 2rem;
}

.person-section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}

.person-section h3 {
  font-size: 1.5rem;
  margin: 0;
  color: #00ff88;
}

.qr-scanner-btn {
  background: linear-gradient(135deg, #00ff9f, #00b8ff);
  color: #000;
  border: none;
  border-radius: 12px;
  padding: 12px 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.9rem;
}

.qr-scanner-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 25px rgba(0, 255, 162, 0.4);
}

.scanner-error-message {
  background: rgba(255, 82, 82, 0.2);
  border: 1px solid #ff5252;
  color: #ff5252;
  padding: 12px 16px;
  border-radius: 8px;
  margin-bottom: 1rem;
  text-align: center;
  font-weight: 500;
}

.persons-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
  gap: 1rem;
  margin-bottom: 1rem;
}

.person-card {
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.05) 0%, rgba(255, 255, 255, 0.02) 100%);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  padding: 1rem;
  cursor: pointer;
  transition: all 0.3s ease;
  text-align: center;
  position: relative;
}

.person-card::before {
  content: '';
  position: absolute;
  top: -2px;
  left: -2px;
  right: -2px;
  bottom: -2px;
  background: linear-gradient(135deg, #00ff88, #00ccff);
  border-radius: 12px;
  opacity: 0;
  transition: opacity 0.3s ease;
  z-index: -1;
}

.person-card:hover {
  transform: translateY(-3px) scale(1.02);
  box-shadow: 0 10px 30px rgba(0, 255, 136, 0.3);
}

.person-card:hover::before {
  opacity: 0.2;
}

.person-card.selected {
  background: linear-gradient(135deg, rgba(0, 255, 136, 0.2) 0%, rgba(0, 204, 255, 0.2) 100%);
  border-color: rgba(0, 255, 136, 0.5);
  transform: translateY(-3px) scale(1.02);
  box-shadow: 0 10px 30px rgba(0, 255, 136, 0.4);
}

.person-card.selected::before {
  opacity: 0.3;
}

.person-icon {
  font-size: 2rem;
  margin-bottom: 0.5rem;
}

.person-name {
  font-size: 1rem;
  font-weight: 600;
  color: white;
  margin-bottom: 0.25rem;
}

.person-detail {
  font-size: 0.8rem;
  color: #888;
  line-height: 1.2;
}

.drink-card {
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.05) 0%, rgba(255, 255, 255, 0.02) 100%);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 16px;
  padding: 1.5rem;
  cursor: pointer;
  transition: all 0.3s ease;
  text-align: center;
  position: relative;
  overflow: hidden;
}

.drink-card::before {
  content: '';
  position: absolute;
  top: -2px;
  left: -2px;
  right: -2px;
  bottom: -2px;
  background: linear-gradient(135deg, #00ff88, #00ccff);
  border-radius: 16px;
  opacity: 0;
  transition: opacity 0.3s ease;
  z-index: -1;
}

.drink-card:hover {
  transform: translateY(-5px) scale(1.02);
  box-shadow: 0 10px 40px rgba(0, 255, 136, 0.2);
}

.drink-card.selected {
  background: linear-gradient(135deg, rgba(0, 255, 136, 0.1) 0%, rgba(0, 204, 255, 0.1) 100%);
  border-color: rgba(0, 255, 136, 0.5);
  animation: pulse 2s infinite;
}

.drink-card.selected::before {
  opacity: 0.1;
}

.drink-icon {
  font-size: 3rem;
  margin-bottom: 0.5rem;
}

.drink-name {
  font-size: 1.1rem;
  font-weight: 600;
  margin-bottom: 0.5rem;
}

.drink-price {
  font-size: 1.5rem;
  font-weight: 700;
  color: #00ff88;
}

.price-indicator {
  position: absolute;
  top: 10px;
  right: 10px;
  font-size: 0.9rem;
  font-weight: 600;
  padding: 0.2rem 0.5rem;
  border-radius: 6px;
}

.price-indicator.up {
  background: rgba(255, 0, 0, 0.2);
  color: #ff4444;
}

.price-indicator.down {
  background: rgba(0, 255, 0, 0.2);
  color: #00ff88;
}

.quantity-section {
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  padding: 1.5rem;
  margin-bottom: 2rem;
}

.quantity-section h3 {
  margin-bottom: 1rem;
  font-size: 1.3rem;
}

.quantity-buttons {
  display: flex;
  gap: 0.5rem;
  margin-bottom: 1rem;
  flex-wrap: wrap;
}

.quantity-btn {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  color: white;
  padding: 0.5rem 1.5rem;
  border-radius: 8px;
  font-size: 1.1rem;
  cursor: pointer;
  transition: all 0.3s ease;
}

.quantity-btn:hover {
  background: rgba(0, 255, 136, 0.1);
  border-color: rgba(0, 255, 136, 0.3);
}

.quantity-btn.selected {
  background: linear-gradient(135deg, rgba(0, 255, 136, 0.2) 0%, rgba(0, 204, 255, 0.2) 100%);
  border-color: rgba(0, 255, 136, 0.5);
}

.custom-quantity input {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  color: white;
  padding: 0.5rem 1rem;
  border-radius: 8px;
  font-size: 1.1rem;
  width: 100px;
}

.purchase-button {
  width: 100%;
  background: linear-gradient(135deg, #00ff88 0%, #00ccff 100%);
  border: none;
  color: #0a0a0a;
  padding: 1rem 2rem;
  border-radius: 12px;
  font-size: 1.3rem;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.purchase-button::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0;
  height: 0;
  background: rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  transform: translate(-50%, -50%);
  transition: width 0.6s, height 0.6s;
}

.purchase-button:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 10px 40px rgba(0, 255, 136, 0.4);
}

.purchase-button:active::before {
  width: 300px;
  height: 300px;
}

.purchase-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  background: linear-gradient(135deg, #444 0%, #555 100%);
}

.sales-history {
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  padding: 1.5rem;
  margin-top: 2rem;
}

.sales-history h3 {
  margin-bottom: 1.5rem;
  font-size: 1.3rem;
  color: #00ff88;
  text-align: center;
}

.sales-list {
  max-height: 400px;
  overflow-y: auto;
}

.sale-item {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  padding: 0.75rem;
  margin-bottom: 0.5rem;
  transition: all 0.3s ease;
}

.sale-item:hover {
  background: rgba(0, 255, 136, 0.05);
  border-color: rgba(0, 255, 136, 0.2);
}

.sale-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.25rem;
}

.sale-drink {
  font-weight: 600;
  color: white;
  flex: 1 1;
}

.sale-quantity {
  color: #00ccff;
  font-weight: 500;
  margin: 0 0.5rem;
}

.sale-price {
  color: #00ff88;
  font-weight: 600;
}

.sale-details {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.85rem;
}

.sale-person {
  color: #888;
}

.sale-time {
  color: #666;
}

.no-sales {
  text-align: center;
  color: #666;
  font-style: italic;
  padding: 2rem;
}`, "",{"version":3,"sources":["webpack://./src/components/BarInterface.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,qDAAqD;EACrD,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,kCAAkC;EAClC,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,iGAAiG;EACjG,0CAA0C;EAC1C,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ,qDAAqD;EACrD,mBAAmB;EACnB,UAAU;EACV,6BAA6B;EAC7B,WAAW;AACb;;AAEA;EACE,uCAAuC;EACvC,8CAA8C;AAChD;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,2FAA2F;EAC3F,oCAAoC;EACpC,uCAAuC;EACvC,8CAA8C;AAChD;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,iGAAiG;EACjG,0CAA0C;EAC1C,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ,qDAAqD;EACrD,mBAAmB;EACnB,UAAU;EACV,6BAA6B;EAC7B,WAAW;AACb;;AAEA;EACE,uCAAuC;EACvC,8CAA8C;AAChD;;AAEA;EACE,2FAA2F;EAC3F,oCAAoC;EACpC,4BAA4B;AAC9B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,0CAA0C;EAC1C,mBAAmB;EACnB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,qCAAqC;EACrC,0CAA0C;EAC1C,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;EAClC,oCAAoC;AACtC;;AAEA;EACE,2FAA2F;EAC3F,oCAAoC;AACtC;;AAEA;EACE,qCAAqC;EACrC,0CAA0C;EAC1C,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,6DAA6D;EAC7D,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,kBAAkB;EAClB,gCAAgC;EAChC,mCAAmC;AACrC;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,uDAAuD;AACzD;;AAEA;EACE,qCAAqC;EACrC,0CAA0C;EAC1C,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,0CAA0C;EAC1C,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;EACnC,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,SAAO;AACT;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,aAAa;AACf","sourcesContent":[".bar-interface {\n  max-width: 1200px;\n  margin: 0 auto;\n  animation: slideIn 0.3s ease;\n}\n\n.bar-interface h2 {\n  font-size: 2.5rem;\n  margin-bottom: 2rem;\n  text-align: center;\n  background: linear-gradient(135deg, #00ff88 0%, #00ccff 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n}\n\n.drinks-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));\n  gap: 1.5rem;\n  margin-bottom: 2rem;\n}\n\n.person-section {\n  margin-bottom: 2rem;\n}\n\n.person-section-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1rem;\n}\n\n.person-section h3 {\n  font-size: 1.5rem;\n  margin: 0;\n  color: #00ff88;\n}\n\n.qr-scanner-btn {\n  background: linear-gradient(135deg, #00ff9f, #00b8ff);\n  color: #000;\n  border: none;\n  border-radius: 12px;\n  padding: 12px 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  font-size: 0.9rem;\n}\n\n.qr-scanner-btn:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 10px 25px rgba(0, 255, 162, 0.4);\n}\n\n.scanner-error-message {\n  background: rgba(255, 82, 82, 0.2);\n  border: 1px solid #ff5252;\n  color: #ff5252;\n  padding: 12px 16px;\n  border-radius: 8px;\n  margin-bottom: 1rem;\n  text-align: center;\n  font-weight: 500;\n}\n\n.persons-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));\n  gap: 1rem;\n  margin-bottom: 1rem;\n}\n\n.person-card {\n  background: linear-gradient(135deg, rgba(255, 255, 255, 0.05) 0%, rgba(255, 255, 255, 0.02) 100%);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 12px;\n  padding: 1rem;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  text-align: center;\n  position: relative;\n}\n\n.person-card::before {\n  content: '';\n  position: absolute;\n  top: -2px;\n  left: -2px;\n  right: -2px;\n  bottom: -2px;\n  background: linear-gradient(135deg, #00ff88, #00ccff);\n  border-radius: 12px;\n  opacity: 0;\n  transition: opacity 0.3s ease;\n  z-index: -1;\n}\n\n.person-card:hover {\n  transform: translateY(-3px) scale(1.02);\n  box-shadow: 0 10px 30px rgba(0, 255, 136, 0.3);\n}\n\n.person-card:hover::before {\n  opacity: 0.2;\n}\n\n.person-card.selected {\n  background: linear-gradient(135deg, rgba(0, 255, 136, 0.2) 0%, rgba(0, 204, 255, 0.2) 100%);\n  border-color: rgba(0, 255, 136, 0.5);\n  transform: translateY(-3px) scale(1.02);\n  box-shadow: 0 10px 30px rgba(0, 255, 136, 0.4);\n}\n\n.person-card.selected::before {\n  opacity: 0.3;\n}\n\n.person-icon {\n  font-size: 2rem;\n  margin-bottom: 0.5rem;\n}\n\n.person-name {\n  font-size: 1rem;\n  font-weight: 600;\n  color: white;\n  margin-bottom: 0.25rem;\n}\n\n.person-detail {\n  font-size: 0.8rem;\n  color: #888;\n  line-height: 1.2;\n}\n\n.drink-card {\n  background: linear-gradient(135deg, rgba(255, 255, 255, 0.05) 0%, rgba(255, 255, 255, 0.02) 100%);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 16px;\n  padding: 1.5rem;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  text-align: center;\n  position: relative;\n  overflow: hidden;\n}\n\n.drink-card::before {\n  content: '';\n  position: absolute;\n  top: -2px;\n  left: -2px;\n  right: -2px;\n  bottom: -2px;\n  background: linear-gradient(135deg, #00ff88, #00ccff);\n  border-radius: 16px;\n  opacity: 0;\n  transition: opacity 0.3s ease;\n  z-index: -1;\n}\n\n.drink-card:hover {\n  transform: translateY(-5px) scale(1.02);\n  box-shadow: 0 10px 40px rgba(0, 255, 136, 0.2);\n}\n\n.drink-card.selected {\n  background: linear-gradient(135deg, rgba(0, 255, 136, 0.1) 0%, rgba(0, 204, 255, 0.1) 100%);\n  border-color: rgba(0, 255, 136, 0.5);\n  animation: pulse 2s infinite;\n}\n\n.drink-card.selected::before {\n  opacity: 0.1;\n}\n\n.drink-icon {\n  font-size: 3rem;\n  margin-bottom: 0.5rem;\n}\n\n.drink-name {\n  font-size: 1.1rem;\n  font-weight: 600;\n  margin-bottom: 0.5rem;\n}\n\n.drink-price {\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: #00ff88;\n}\n\n.price-indicator {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  font-size: 0.9rem;\n  font-weight: 600;\n  padding: 0.2rem 0.5rem;\n  border-radius: 6px;\n}\n\n.price-indicator.up {\n  background: rgba(255, 0, 0, 0.2);\n  color: #ff4444;\n}\n\n.price-indicator.down {\n  background: rgba(0, 255, 0, 0.2);\n  color: #00ff88;\n}\n\n.quantity-section {\n  background: rgba(255, 255, 255, 0.03);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 12px;\n  padding: 1.5rem;\n  margin-bottom: 2rem;\n}\n\n.quantity-section h3 {\n  margin-bottom: 1rem;\n  font-size: 1.3rem;\n}\n\n.quantity-buttons {\n  display: flex;\n  gap: 0.5rem;\n  margin-bottom: 1rem;\n  flex-wrap: wrap;\n}\n\n.quantity-btn {\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  color: white;\n  padding: 0.5rem 1.5rem;\n  border-radius: 8px;\n  font-size: 1.1rem;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.quantity-btn:hover {\n  background: rgba(0, 255, 136, 0.1);\n  border-color: rgba(0, 255, 136, 0.3);\n}\n\n.quantity-btn.selected {\n  background: linear-gradient(135deg, rgba(0, 255, 136, 0.2) 0%, rgba(0, 204, 255, 0.2) 100%);\n  border-color: rgba(0, 255, 136, 0.5);\n}\n\n.custom-quantity input {\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  color: white;\n  padding: 0.5rem 1rem;\n  border-radius: 8px;\n  font-size: 1.1rem;\n  width: 100px;\n}\n\n.purchase-button {\n  width: 100%;\n  background: linear-gradient(135deg, #00ff88 0%, #00ccff 100%);\n  border: none;\n  color: #0a0a0a;\n  padding: 1rem 2rem;\n  border-radius: 12px;\n  font-size: 1.3rem;\n  font-weight: 700;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  position: relative;\n  overflow: hidden;\n}\n\n.purchase-button::before {\n  content: '';\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  width: 0;\n  height: 0;\n  background: rgba(255, 255, 255, 0.3);\n  border-radius: 50%;\n  transform: translate(-50%, -50%);\n  transition: width 0.6s, height 0.6s;\n}\n\n.purchase-button:hover:not(:disabled) {\n  transform: translateY(-2px);\n  box-shadow: 0 10px 40px rgba(0, 255, 136, 0.4);\n}\n\n.purchase-button:active::before {\n  width: 300px;\n  height: 300px;\n}\n\n.purchase-button:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n  background: linear-gradient(135deg, #444 0%, #555 100%);\n}\n\n.sales-history {\n  background: rgba(255, 255, 255, 0.03);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 12px;\n  padding: 1.5rem;\n  margin-top: 2rem;\n}\n\n.sales-history h3 {\n  margin-bottom: 1.5rem;\n  font-size: 1.3rem;\n  color: #00ff88;\n  text-align: center;\n}\n\n.sales-list {\n  max-height: 400px;\n  overflow-y: auto;\n}\n\n.sale-item {\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 8px;\n  padding: 0.75rem;\n  margin-bottom: 0.5rem;\n  transition: all 0.3s ease;\n}\n\n.sale-item:hover {\n  background: rgba(0, 255, 136, 0.05);\n  border-color: rgba(0, 255, 136, 0.2);\n}\n\n.sale-info {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 0.25rem;\n}\n\n.sale-drink {\n  font-weight: 600;\n  color: white;\n  flex: 1;\n}\n\n.sale-quantity {\n  color: #00ccff;\n  font-weight: 500;\n  margin: 0 0.5rem;\n}\n\n.sale-price {\n  color: #00ff88;\n  font-weight: 600;\n}\n\n.sale-details {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-size: 0.85rem;\n}\n\n.sale-person {\n  color: #888;\n}\n\n.sale-time {\n  color: #666;\n}\n\n.no-sales {\n  text-align: center;\n  color: #666;\n  font-style: italic;\n  padding: 2rem;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
